import { StackedLineData } from 'components/Charts/StackedLineChart'

export const HARDCODED_TVL_DATA = [
  { time: 1702500046, values: [1000000] },
  { time: 1702500146, values: [1400000] },
  { time: 1702500246, values: [1300000] },
  { time: 1702500346, values: [2000000] },
  { time: 1702500446, values: [1000000] },
  { time: 1702500546, values: [4000000] },
  { time: 1702500646, values: [9250000] },
  { time: 1702500746, values: [6000000] },
  { time: 1702500846, values: [5000000] },
  { time: 1702500946, values: [6000000] },
  { time: 1702501046, values: [10000000] },
  { time: 1702501146, values: [11000000] },
  { time: 1702501246, values: [5000000] },
  { time: 1702501346, values: [11000000] },
  { time: 1702501446, values: [2000000] },
  { time: 1702501546, values: [1900000] },
] as StackedLineData[]
